import { Skeleton } from "@/components/ui/skeleton";

interface RouteFallbackProps {
  variant?: "backoffice" | "proposal";
}

export function RouteFallback({ variant = "backoffice" }: RouteFallbackProps) {
  if (variant === "proposal") {
    return (
      <div
        role="status"
        aria-label="Carregando página"
        className="min-h-screen flex flex-col bg-[#1A1814]"
      >
        <div className="flex items-center justify-between px-8 h-[76px] border-b border-white/[0.08]">
          <Skeleton className="h-6 w-24 bg-white/10" />
          <div className="flex items-center gap-4">
            <Skeleton className="h-8 w-16 rounded-full bg-white/10" />
            <Skeleton className="h-8 w-36 rounded-full bg-white/10" />
          </div>
        </div>
        <div className="flex-1 px-6 py-12">
          <div className="max-w-6xl mx-auto space-y-6">
            <Skeleton className="h-4 w-40 bg-white/10" />
            <Skeleton className="h-12 w-3/4 bg-white/10" />
            <Skeleton className="h-12 w-1/2 bg-white/10" />
            <Skeleton className="h-64 w-full rounded-2xl bg-white/5" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div role="status" aria-label="Carregando página" className="p-8 space-y-6">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-4 w-96" />
      <div className="space-y-3 pt-4">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-2/3" />
      </div>
    </div>
  );
}
